import { Record } from 'immutable';
import { AREA_TEXTS, BODY_FIGURE_TEXTS, AGE_RANGE_TEXTS, HEIGHT_RANGE_TEXTS, FORUM_STATUS_TEXTS } from '../consts';

export type ApiForumPost = {
  id: number;
  area: string;
  blood_type: string[] | null;
  age_range: string[] | null;
  body_figure: string[] | null;
  height_range: string[] | null;
  description: string | null;
  status: string;
  expires_at: string | null;
  posted_at: string | null;
  created_at: string;
  applications_count: number;
  applied: boolean;
  donee: { name_f: string; birth_date: string | null } | null;
};

const ForumPostBase = Record({
  id: 0,
  area: '',
  bloodType: null as string[] | null,
  ageRange: null as string[] | null,
  bodyFigure: null as string[] | null,
  heightRange: null as string[] | null,
  description: null as string | null,
  status: '',
  expiresAt: null as string | null,
  postedAt: null as string | null,
  createdAt: '',
  applicationsCount: 0,
  applied: false,
  doneeNameF: '',
  doneeBirthDate: null as string | null,
});

export class ForumPost extends ForumPostBase {
  constructor(api?: ApiForumPost) {
    super({
      id: api?.id,
      area: api?.area,
      bloodType: api?.blood_type?.length ? api.blood_type : null,
      ageRange: api?.age_range?.length ? api.age_range : null,
      bodyFigure: api?.body_figure?.length ? api.body_figure : null,
      heightRange: api?.height_range?.length ? api.height_range : null,
      description: api?.description,
      status: api?.status,
      expiresAt: api?.expires_at,
      postedAt: api?.posted_at || null,
      createdAt: api?.created_at,
      applicationsCount: api?.applications_count || 0,
      applied: api?.applied ?? false,
      doneeNameF: api?.donee?.name_f || '',
      doneeBirthDate: api?.donee?.birth_date || null,
    });
  }

  readonly areaText: string = AREA_TEXTS[this.area] || this.area;
  readonly bloodTypeText: string = this.bloodType?.join(' / ') || '';
  readonly bloodTypeChips: string[] = this.bloodType?.map(t => `${ t }型`) || [];
  readonly ageRangeText: string = this.ageRange?.map(k => AGE_RANGE_TEXTS[k] || k).join(' / ') || '';
  readonly bodyFigureText: string = this.bodyFigure?.map(k => BODY_FIGURE_TEXTS[k] || k).join(' / ') || '';
  readonly heightRangeText: string = this.heightRange?.map(k => HEIGHT_RANGE_TEXTS[k] || k).join(' / ') || '';
  readonly statusText: string = FORUM_STATUS_TEXTS[this.status] || this.status;

  readonly isOpen: boolean = this.status === 'OPEN';
  readonly isDraft: boolean = this.status === 'DRAFT';

  readonly daysLeft: number = this.expiresAt
    ? Math.max(0, Math.round(
        (new Date(this.expiresAt.slice(0, 10)).getTime() -
         Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) /
        86400000
      ))
    : 0;

  readonly createdAtText: string = this.createdAt ? this.createdAt.slice(0, 10).replace(/-/g, '/') : '';
  readonly postedAtText: string = this.postedAt ? this.postedAt.slice(0, 10).replace(/-/g, '/') : '';
  readonly expiresAtText: string = this.expiresAt ? this.expiresAt.slice(0, 10).replace(/-/g, '/') : '';

  readonly doneeAgeText: string = (() => {
    if (!this.doneeBirthDate) return '';
    const age = Math.floor((Date.now() - new Date(this.doneeBirthDate).getTime()) / (1000 * 60 * 60 * 24 * 365.25));
    return `${ Math.floor(age / 10) * 10 }代`;
  })();
}
